import {useEffect, useState} from 'react'
import {Awaited} from '../common/types'
import {Spotify} from '../lib/spotify'

export const useTrackListener = () => {
  const [state, setState] =
    useState<Awaited<ReturnType<typeof Spotify.getCurrentlyPlaying>>>()
  useEffect(() => {
    let timeout: ReturnType<typeof setTimeout>
    const request = () =>
      Spotify.getCurrentlyPlaying()
        .then(setState)
        .finally(() => {
          timeout = setTimeout(() => request(), 3000)
        })

    request()
    return () => {
      clearTimeout(timeout)
    }
  }, [])
  return state
}
